module.exports = __webpack_public_path__ + "static/media/rober12.bce56b9e.jpg";